require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-keeping-ray-sweet.json") })
        }
      }, "path---authors-keeping-ray-sweet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-keeping-ray-sweet!./.cache/json/authors-keeping-ray-sweet.json
// module id = 1302
// module chunks = 231608221292675